/* @generated */

// ../src/carousel/carousel.tsx
import classNames2 from "classnames";
import * as React4 from "react";

// ../src/carousel/carousel_context.tsx
import * as React from "react";
var defaultValues = {
  activeSlide: 0,
  showPager: false,
  slideHeight: 0,
  totalSlides: 0,
  transitionDuration: "1400ms",
  isTransitioningFrom: -1,
  stopTransitioning: () => ({})
};
var CarouselContext = React.createContext(defaultValues);

// ../src/carousel/carousel_slide_column.tsx
import classNames from "classnames";
import * as React3 from "react";

// ../src/carousel/carousel_slide_context.tsx
import * as React2 from "react";
var defaultValues2 = {
  isActive: false,
  isTransitioningFrom: -1,
  // NOTE(vutran) - Intentionally left open to the user to pass in any color.
  primaryColor: "#0D2481",
  inverted: false,
  columnIndex: 0,
  slideIndex: 0,
  transformY: 0
};
var CarouselSlideContext = React2.createContext(defaultValues2);

// ../src/carousel/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var carouselButton = "dig-1tuduy6d_21-7-0";
var carouselColumn = "dig-1tuduy69_21-7-0";
var carouselContainer = "dig-1tuduy63_21-7-0";
var carouselHeading = "dig-1tuduy6e_21-7-0";
var carouselPager = "dig-1tuduy6b_21-7-0";
var carouselRecipe = _7a468({ defaultClassName: "dig-1tuduy60_21-7-0", variantClassNames: { borderRadius: { XLarge: "dig-1tuduy61_21-7-0", None: "dig-1tuduy62_21-7-0" } }, defaultVariants: { borderRadius: "XLarge" }, compoundVariants: [] });
var carouselSlide = _7a468({ defaultClassName: "dig-1tuduy64_21-7-0", variantClassNames: { isInverted: { true: "dig-1tuduy65_21-7-0" }, isActive: { true: "dig-1tuduy66_21-7-0" }, isTransitioning: { true: "dig-1tuduy67_21-7-0" } }, defaultVariants: {}, compoundVariants: [[{ isTransitioning: false, isActive: false }, "dig-1tuduy68_21-7-0"]] });
var carouselSlideActions = "dig-1tuduy6c_21-7-0";
var carouselSlideColumnContent = "dig-1tuduy6a_21-7-0";
var carouselText = "dig-1tuduy6f_21-7-0";

// ../src/carousel/carousel_slide_column.tsx
var COLUMN = /* @__PURE__ */ ((COLUMN2) => {
  COLUMN2[COLUMN2["CONTENT"] = 0] = "CONTENT";
  COLUMN2[COLUMN2["MEDIA"] = 1] = "MEDIA";
  return COLUMN2;
})(COLUMN || {});
var CarouselSlideColumn = React3.forwardRef(
  (props, ref) => {
    const {
      className,
      children,
      columnIndex: columnIndexFromProps,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onTransitionEnd,
      renderPager,
      ...rest
    } = props;
    const cls = classNames("dig-Carousel-column", carouselColumn, className);
    const { showPager, totalSlides, transitionDuration } = React3.useContext(CarouselContext);
    const { primaryColor, inverted, columnIndex, slideIndex, transformY, isActive, onSlideEnd } = React3.useContext(CarouselSlideContext);
    const style = {
      transitionDuration,
      transform: `translate3d(0, ${transformY}px, 0)`
    };
    const pagerStyle = {};
    if (primaryColor) {
      switch (columnIndex) {
        case 1 /* MEDIA */:
          if (!inverted) {
            style.backgroundColor = primaryColor;
          }
          break;
        case 0 /* CONTENT */:
          if (inverted) {
            style.backgroundColor = primaryColor;
            pagerStyle.color = "var(--dig-color__background__base, #fff)";
          }
          break;
      }
    }
    const transitionEnd = React3.useCallback(
      (evt) => {
        if (onSlideEnd) {
          if (evt && evt.target === evt.currentTarget) {
            onSlideEnd({ columnIndex: columnIndexFromProps || columnIndex, slideIndex }, evt);
          }
        }
      },
      [columnIndex, columnIndexFromProps, onSlideEnd, slideIndex]
    );
    React3.useEffect(() => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden" && // Rather than every slide calling onSlideEnd, just let the active one do it
      isActive && onSlideEnd) {
        onSlideEnd({ columnIndex: columnIndexFromProps || columnIndex, slideIndex }, null);
      }
    }, [columnIndex, columnIndexFromProps, isActive, onSlideEnd, slideIndex]);
    const pagerChildren = typeof renderPager === "function" ? renderPager({ slideIndex: slideIndex + 1, totalSlides }) : `${slideIndex + 1} of ${totalSlides}`;
    return /* @__PURE__ */ React3.createElement(
      "div",
      {
        className: cls,
        style,
        tabIndex: -1,
        onTransitionEnd: transitionEnd,
        ref,
        ...rest
      },
      columnIndex === 0 /* CONTENT */ && showPager && /* @__PURE__ */ React3.createElement("div", { className: classNames("dig-Carousel-pager", carouselPager), style: pagerStyle }, pagerChildren),
      children
    );
  }
);
CarouselSlideColumn.displayName = "CarouselSlideColumn";

// ../src/carousel/carousel.tsx
import { usePrefersReducedMotion } from "@dropbox/dig-foundations";
var Carousel = ({
  children,
  className,
  height,
  showPager = false,
  borderRadius = "XLarge",
  style,
  totalSlides,
  transitionDuration: _transitionDuration = "1400ms",
  width,
  defaultIndex,
  onClose,
  onSlide,
  onSlideTransitioned,
  ...rest
}) => {
  const [activeSlide, setActiveSlide] = React4.useState(defaultIndex || 0);
  const [isTransitioningFrom, setIsTransitioningFrom] = React4.useState(-1);
  const { hasReducedMotion } = usePrefersReducedMotion();
  const transitionDuration = hasReducedMotion ? "0ms" : _transitionDuration;
  const cls = classNames2("dig-Carousel", carouselRecipe({ borderRadius }), className);
  const styl = {
    ...style,
    width,
    height
  };
  const isTransitioning = () => isTransitioningFrom > -1;
  const stopTransitioning = (options) => {
    if (!isTransitioning()) {
      return;
    }
    if (activeSlide !== totalSlides - 1 && options.columnIndex !== 1 /* MEDIA */) {
      return;
    }
    setIsTransitioningFrom(-1);
    if (onSlideTransitioned) {
      onSlideTransitioned(activeSlide);
    }
  };
  const goToNext = () => {
    if (isTransitioning()) {
      return;
    }
    if (activeSlide < totalSlides - 1) {
      setIsTransitioningFrom(activeSlide);
      setActiveSlide((prev) => prev + 1);
      if (onSlide) {
        onSlide(activeSlide + 1);
      }
    }
  };
  const goToPrevious = () => {
    if (isTransitioning()) {
      return;
    }
    if (activeSlide > 0) {
      setIsTransitioningFrom(activeSlide);
      setActiveSlide((prev) => prev - 1);
      if (onSlide) {
        onSlide(activeSlide - 1);
      }
    }
  };
  const goToSlide = (slideIndex, force) => {
    if (!force && (isTransitioning() || slideIndex === activeSlide)) {
      return;
    }
    if (slideIndex >= 0 && slideIndex < totalSlides) {
      setIsTransitioningFrom(activeSlide);
      setActiveSlide(slideIndex);
      if (onSlide) {
        onSlide(slideIndex);
      }
    }
  };
  const close = () => {
    if (onClose) {
      onClose();
    }
  };
  const value = {
    activeSlide,
    showPager,
    slideHeight: height,
    totalSlides,
    transitionDuration,
    isTransitioningFrom,
    stopTransitioning
  };
  return /* @__PURE__ */ React4.createElement(CarouselContext.Provider, { value }, /* @__PURE__ */ React4.createElement("div", { className: cls, style: styl, ...rest }, children({
    activeSlide,
    totalSlides,
    isTransitioningFrom,
    goToNext,
    goToPrevious,
    goToSlide,
    close
  })));
};
Carousel.displayName = "Carousel";

// ../src/carousel/carousel_button.tsx
import classNames3 from "classnames";
import * as React5 from "react";
import { Button } from "@dropbox/dig-components/buttons";
var CarouselButton = ({
  className,
  style,
  variant,
  tabIndex: oTabIndex,
  ...rest
}) => {
  const cls = classNames3("dig-Carousel-button", carouselButton, className);
  return /* @__PURE__ */ React5.createElement(CarouselSlideContext.Consumer, null, ({ isActive, isTransitioningFrom = -1, inverted }) => {
    const styl = { ...style };
    const tabIndex = isTransitioningFrom > -1 || !isActive ? -1 : oTabIndex;
    return /* @__PURE__ */ React5.createElement(
      Button,
      {
        className: cls,
        style: styl,
        variant,
        inverse: inverted,
        tabIndex,
        ...rest
      }
    );
  });
};
CarouselButton.displayName = "CarouselButton";

// ../src/carousel/carousel_container.tsx
import classNames4 from "classnames";
import * as React6 from "react";
function clamp(value, [min, max]) {
  return Math.min(Math.max(value, min), max);
}
var CarouselContainer = ({
  className,
  children,
  ...rest
}) => {
  const cls = classNames4("dig-Carousel-container", carouselContainer, className);
  return /* @__PURE__ */ React6.createElement(CarouselContext.Consumer, null, ({ activeSlide, slideHeight, stopTransitioning, isTransitioningFrom }) => /* @__PURE__ */ React6.createElement("div", { className: cls, ...rest }, React6.Children.map(children, (child, slideIndex) => {
    if (React6.isValidElement(child)) {
      const isActive = activeSlide === slideIndex;
      const transformY = isActive ? 0 : (
        // Prevent unnecessary animating beyond the adjacent area
        clamp(slideHeight * (slideIndex - activeSlide), [-1 * slideHeight, slideHeight])
      );
      return React6.cloneElement(child, {
        isActive,
        isTransitioningFrom,
        slideIndex,
        transformY,
        onSlideEnd: stopTransitioning
      });
    }
  })));
};

// ../src/carousel/carousel_heading.tsx
import classNames5 from "classnames";
import * as React7 from "react";
function CarouselHeading({ className, ...rest }) {
  const cls = classNames5("dig-Carousel-heading", carouselHeading, className);
  return /* @__PURE__ */ React7.createElement("h1", { className: cls, ...rest });
}

// ../src/carousel/carousel_slide.tsx
import classNames6 from "classnames";
import * as React8 from "react";
var CarouselSlide = React8.forwardRef((props, ref) => {
  const {
    className,
    children,
    inverted = false,
    isActive,
    isTransitioningFrom = -1,
    onSlideEnd,
    primaryColor,
    slideIndex = 0,
    transformY = 0,
    ...rest
  } = props;
  const cls = classNames6(
    "dig-Carousel-slide",
    className,
    {
      "dig-Carousel-slide-active": isActive,
      "dig-Carousel-slide-inverted": inverted,
      "dig-Carousel-slide-transitioning": isActive && isTransitioningFrom > -1 || isTransitioningFrom === slideIndex
    },
    carouselSlide({
      isActive,
      isInverted: inverted,
      isTransitioning: isActive && isTransitioningFrom > -1 || isTransitioningFrom === slideIndex
    })
  );
  return /* @__PURE__ */ React8.createElement("div", { className: cls, "aria-hidden": !isActive, tabIndex: -1, ref, ...rest }, React8.Children.map(children, (child, columnIndex) => {
    const slideContext = {
      isActive,
      isTransitioningFrom,
      primaryColor,
      inverted,
      // these properties are passed down to the context for consumption via the column
      // components. column components can be wrapped by some `n` number of intermediate
      // components so we can't do manual prop passing, rather context is used.
      // In the case, where intermediate components are used, a `prop.columnIndex` would need
      // to be set on `CarouselSlideColumn` explicitly otherwise, the call to
      // `React.children.map` would be incorrect applied to here.
      columnIndex,
      slideIndex,
      transformY,
      onSlideEnd
    };
    return /* @__PURE__ */ React8.createElement(CarouselSlideContext.Provider, { value: slideContext }, child);
  }));
});
CarouselSlide.displayName = "CarouselSlide";

// ../src/carousel/carousel_slide_actions.tsx
import classNames7 from "classnames";
import * as React9 from "react";
function CarouselSlideActions({
  className,
  ...rest
}) {
  const cls = classNames7("dig-Carousel-slide-actions", carouselSlideActions, className);
  return /* @__PURE__ */ React9.createElement("div", { className: cls, ...rest });
}

// ../src/carousel/carousel_slide_column_content.tsx
import classNames8 from "classnames";
import * as React10 from "react";
function CarouselSlideColumnContent({
  className,
  ...rest
}) {
  const cls = classNames8(
    "dig-Carousel-slide-column-content",
    carouselSlideColumnContent,
    className
  );
  return /* @__PURE__ */ React10.createElement("div", { className: cls, ...rest });
}

// ../src/carousel/carousel_text.tsx
import classNames9 from "classnames";
import * as React11 from "react";
function CarouselText({ className, ...rest }) {
  const cls = classNames9("dig-Carousel-text", carouselText, className);
  return /* @__PURE__ */ React11.createElement("div", { className: cls, ...rest });
}

// ../src/carousel/hooks.ts
import * as React12 from "react";
var useFocusSlideOnTransition = (slideRefs) => {
  if (slideRefs.length <= 0) {
    throw new Error("slideRefs length must be a positive integer");
  }
  React12.useEffect(() => {
    if (slideRefs[0].current) {
      slideRefs[0].current.focus();
    }
  }, [slideRefs[0].current]);
  const handleSlideTransitioned = React12.useCallback(
    (slideIndex) => {
      const current = slideRefs[slideIndex].current;
      if (current) {
        current.focus();
      }
    },
    [slideRefs]
  );
  return handleSlideTransitioned;
};
export {
  COLUMN,
  Carousel,
  CarouselButton,
  CarouselContainer,
  CarouselContext,
  CarouselHeading,
  CarouselSlide,
  CarouselSlideActions,
  CarouselSlideColumn,
  CarouselSlideColumnContent,
  CarouselText,
  useFocusSlideOnTransition
};
